<template>
  <div class="flex flex-col w-full animate-pulse relative">
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-3 mb-1">
        <div class="h-8 w-40 bg-slate-200 rounded-lg border border-slate-300"></div>
        <div class="h-8 w-48 bg-slate-200 rounded"></div>
      </div>
      <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
    </div>

    <div
      class="absolute right-[2.5vw] top-[40px] flex flex-col items-end gap-3 z-10 pointer-events-none"
    >
      <div class="w-12 h-12 rounded-full bg-slate-200 border-2 border-white shadow-sm"></div>
      <div class="w-12 h-12 rounded-full bg-slate-200 border-2 border-white shadow-sm"></div>
      <div class="w-12 h-12 rounded-full bg-slate-200 border-2 border-white shadow-sm"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
